export const parseTurkishFloat = (value: any) => {
  if (!value) return 0;
  
  if (typeof value === 'number') return value;

  return parseFloat(
    value
      .replace(/\./g, '')
      .replace(',', '.')
  ) || 0;
};